// =============================================================================
// akademiaUzytkownikaCore — czysty rdzeń Akademii Universe użytkownika.
//
// 13.09.2026 (Jan-Dar): użytkownik najemcy po Genesis nie miał drugiego
// wejścia do prezentacji modułów ani rozdziałów z postępem. Akademia
// użytkownika czyta ten sam program co partner (`?odbiorca=uzytkownik`)
// i dokłada do rozdziałów organowych dwie rzeczy z bazy: „Skąd ta nazwa"
// (`modules.name_meaning_pl`, 694) i „Co to znaczy dla Was"
// (`genesis_narracja_modulow.narracja_pl`, 692). Tu jest wyłącznie
// złożenie tych wierszy w mapę per klucz rozdziału — klucz rozdziału
// organowego jest slugiem organu (`szkolenieCore.ts`: `klucz === organy[0]`).
// =============================================================================

import type { WstawkaOrganu } from '../../components/akademia/KursSzkolenia';

export interface WierszZnaczenia {
  id: string;
  name_meaning_pl: string | null;
}

export interface WierszNarracji {
  modul: string;
  narracja_pl: string;
}

function niepuste(tekst: string | null | undefined): string | null {
  const t = (tekst ?? '').trim();
  return t ? t : null;
}

/**
 * Mapa `klucz rozdziału → wstawka`. Organ bez żadnego wiersza NIE dostaje
 * wpisu (kurs pomija sekcję, nie pokazuje pustej ramki); NULL w kolumnie =
 * brak tego jednego pola.
 */
export function zbudujWstawki(
  moduly: readonly WierszZnaczenia[],
  narracje: readonly WierszNarracji[]
): Record<string, WstawkaOrganu> {
  const mapa: Record<string, WstawkaOrganu> = {};
  for (const m of moduly) {
    const znaczenie = niepuste(m.name_meaning_pl);
    if (znaczenie) mapa[m.id] = { ...(mapa[m.id] ?? {}), znaczenieNazwy: znaczenie };
  }
  for (const n of narracje) {
    const dlaWas = niepuste(n.narracja_pl);
    if (dlaWas) mapa[n.modul] = { ...(mapa[n.modul] ?? {}), dlaWas };
  }
  return mapa;
}
